import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { LocationLandingPage } from './LocationLandingPage';

export function NeighborhoodLandingPage() {
  const { id } = useParams<{ id: string }>();
  const neighborhoodId = Number(id);
  if (!neighborhoodId) return <Navigate to="/dashboard" replace />;
  return <LocationLandingPage mode="neighborhood" id={neighborhoodId} />;
}
